import { differenceInCalendarDays, endOfDay, startOfDay } from "date-fns";

/**
 * Resolves API breakdown for home KPI sparklines from the selected date range.
 * 1–14 days: daily; 15–119 days: weekly; 120+ days: monthly.
 * @param {{ startDateTime?: number, endDateTime?: number }} dateRange
 * @returns {"daily"|"weekly"|"monthly"|null}
 */
export const resolveHomeKpiBreakdown = (dateRange = {}) => {
  const { startDateTime, endDateTime } = dateRange;

  if (!startDateTime || !endDateTime) {
    return null;
  }

  const start = startOfDay(new Date(startDateTime));
  const end = endOfDay(new Date(endDateTime));
  const rangeDays = Math.max(1, differenceInCalendarDays(end, start) + 1);

  if (rangeDays <= 14) {
    return "daily";
  }

  if (rangeDays <= 119) {
    return "weekly";
  }

  return "monthly";
};

export default resolveHomeKpiBreakdown;
